import { ProblemDocument } from 'http-problem-details';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProblemRendererBodyComponent extends Vue {
  @Prop({ required: true, type: Object })
  public value!: any;

  public get detail(): string {
    return this.value.detail ? this.value.detail : this.value.title;
  }

  public get tipo(): string {
    return this.value.type;
  }

  public get instancia(): string {
    return this.value.instance;
  }

  public get estatus(): number {
    return this.value.status;
  }

  public get complemento(): string {
    return this.value.keyI18n;
  }

  public get requiereComplemento(): boolean {
    const keyI18n = this.value.keyI18n;
    return keyI18n && this.$t(`${keyI18n}.mensaje`) !== '';
  }

  public get extensionMembers(): Array<any> {
    let members: Array<any>;
    for (const clave in this.value) {
      if (this.value[clave] && this.isExtensionMember(clave)) {
        if (!members) {
          members = [];
        }
        members.push([clave, this.value[clave]]);
      }
    }
    return members;
  }

  private isExtensionMember(member: string): boolean {
    return member !== 'type' && member !== 'detail' && member !== 'instance' && member !== 'status' && member !== 'title';
  }
}
